
function Piedpage(){
    return(
        <>
            <footer>
                 &copy; 2024 Mon Ecole. Tous droits réservés.
            </footer>
        </>
    )
}
export default Piedpage;